<template>
  <ArtImportDialog
    v-if="artImportDialogShow"
    :dialogType="1"
    :file="currentFile"
    :termInfo="termInfo"
    :parmas="excelJson"
    @onClose="onCloseDialog"
    @onConfirm="onImportConfirmDialog"
  />
  <ArtLibraryDialog
    v-if="artDialogShow"
    ref="artLibraryDialogRef"
    :dialogType="artDialogType"
    @onClose="onCloseDialog"
    @onConfirm="onConfirmDialog"
  />

  <div class="glossary-editor">
    <el-upload
      id="art-edit-upload"
      ref="uploadRef"
      class="glossary-editor__upload"
      action=""
      :key="uploadKey"
      :before-upload="handleBeforeUpload"
      :on-change="handleUploadFile"
      :webkitdirectory="false"
      :mozdirectory="false"
      :auto-upload="false"
      :show-file-list="false"
      accept=".xls, .xlsx"
      :multiple="false"
    />

    <div class="glossary-editor__toolbar">
      <label class="glossary-editor__search">
        <WorkbenchIcon name="search" :size="15" />
        <input v-model="searchString" type="search" :placeholder="$t('art_search')" />
      </label>

      <div class="glossary-editor__actions">
        <el-tooltip effect="dark" placement="top" :content="$t('art_download_excel')">
          <button class="glossary-editor__icon-button" type="button" @click="onDownloadFile">
            <WorkbenchIcon name="download" :size="16" />
          </button>
        </el-tooltip>
        <el-tooltip effect="dark" placement="top" :content="$t('art_import_excel')">
          <button class="glossary-editor__icon-button" type="button" @click="onUploadFile">
            <WorkbenchIcon name="upload" :size="16" />
          </button>
        </el-tooltip>
        <span class="glossary-editor__divider" />
        <button
          class="glossary-editor__button glossary-editor__button--primary"
          type="button"
          :disabled="addFileList.length > 0"
          @click="onAddArtEntry"
        >
          <WorkbenchIcon name="plus" :size="14" />
          {{ $t('art_add_entry') }}
        </button>
        <button class="glossary-editor__button" type="button" @click="onExportArt">
          <WorkbenchIcon name="download" :size="14" />
          {{ $t('art_export_excel') }}
        </button>
        <button
          class="glossary-editor__button"
          type="button"
          :disabled="getDeleteChooses() === 0"
          @click="onDeleteArt"
        >
          <WorkbenchIcon name="trash-2" :size="14" />
          {{ $t('art_delete_entry') }}
        </button>
      </div>
    </div>

    <div id="artLibraryList" class="glossary-editor__table-shell">
      <div class="glossary-editor__table-header glossary-entry-grid">
        <button class="glossary-editor__check" type="button" :aria-pressed="isChooseAll" @click="onChooseAll">
          <WorkbenchIcon v-if="isChooseAll" name="check" :size="11" />
        </button>
        <span>{{ $t('art_entry_header_title1') }}</span>
        <span>{{ $t('art_entry_header_title2') }}</span>
        <span>{{ $t('art_entry_header_title3') }}</span>
        <span class="glossary-editor__operation-title">{{ $t('art_entry_header_title4') }}</span>
      </div>

      <div id="fileArtList" class="glossary-editor__table-body">
        <div v-for="(item, index) in addFileList" :key="`new-${item.id}`" class="glossary-entry-row glossary-entry-grid is-editing">
          <span />
          <span class="glossary-entry-index">—</span>
          <div class="glossary-entry-field">
            <input
              :class="getLeftInputClass(item.id)"
              type="text"
              :value="operateArtMap[item.id].entryKey"
              :placeholder="$t('art_create_placeholder')"
              @input="(event) => handleLeftInput(event, item)"
              @blur="operateArtMap[item.id].leftFocus = false"
              @focus="operateArtMap[item.id].leftFocus = true"
            />
            <small v-if="item.leftError">{{ item.leftError == 2 ? $t('art_error_tips1') : $t('art_error_tips2') }}</small>
            <em>{{ operateArtMap[item.id].entryKey?.length || 0 }}/50</em>
          </div>
          <div class="glossary-entry-field">
            <input
              :class="getRightInputClass(item.id)"
              type="text"
              :value="operateArtMap[item.id].entryValue"
              :placeholder="$t('art_create_placeholder')"
              @input="(event) => handleRightInput(event, item)"
              @blur="operateArtMap[item.id].rightFocus = false"
              @focus="operateArtMap[item.id].rightFocus = true"
            />
            <small v-if="item.rightError">{{ $t('art_error_tips3') }}</small>
            <em>{{ operateArtMap[item.id].entryValue?.length || 0 }}/50</em>
          </div>
          <span class="glossary-entry-actions">
            <button class="is-success" type="button" @click="onCompleteEdit(index, item)">
              <WorkbenchIcon name="check" :size="13" />{{ $t('art_complete_edit') }}
            </button>
            <button class="is-danger" type="button" @click="onCancelEdit(index, item)">
              <WorkbenchIcon name="x" :size="13" />{{ $t('art_cancel_edit') }}
            </button>
          </span>
        </div>

        <div v-for="(item, index) in fileList" :key="item.id" class="glossary-entry-row glossary-entry-grid" :class="{ 'is-editing': operateArtMap[item.id] }">
          <button class="glossary-editor__check" type="button" :aria-pressed="Boolean(fileMap[item.id])" @click="onChooseItem(item)">
            <WorkbenchIcon v-if="fileMap[item.id]" name="check" :size="11" />
          </button>
          <span class="glossary-entry-index">{{ item.id }}</span>

          <div v-if="operateArtMap[item.id]" class="glossary-entry-field">
            <input
              :class="getLeftInputClass(item.id)"
              type="text"
              :value="operateArtMap[item.id].entryKey"
              :placeholder="$t('art_create_placeholder')"
              @input="(event) => handleLeftInput(event, item)"
              @blur="operateArtMap[item.id].leftFocus = false"
              @focus="operateArtMap[item.id].leftFocus = true"
            />
            <small v-if="item.leftError">{{ item.leftError == 2 ? $t('art_error_tips1') : $t('art_error_tips2') }}</small>
            <em>{{ operateArtMap[item.id].entryKey?.length || 0 }}/50</em>
          </div>
          <el-tooltip v-else effect="dark" placement="top" :content="item.entryKey">
            <span class="glossary-entry-text">{{ item.entryKey }}</span>
          </el-tooltip>

          <div v-if="operateArtMap[item.id]" class="glossary-entry-field">
            <input
              :class="getRightInputClass(item.id)"
              type="text"
              :value="operateArtMap[item.id].entryValue"
              :placeholder="$t('art_create_placeholder')"
              @input="(event) => handleRightInput(event, item)"
              @blur="operateArtMap[item.id].rightFocus = false"
              @focus="operateArtMap[item.id].rightFocus = true"
            />
            <small v-if="item.rightError">{{ $t('art_error_tips3') }}</small>
            <em>{{ operateArtMap[item.id].entryValue?.length || 0 }}/50</em>
          </div>
          <el-tooltip v-else effect="dark" placement="top" :content="item.entryValue">
            <span class="glossary-entry-text">{{ item.entryValue }}</span>
          </el-tooltip>

          <span class="glossary-entry-actions">
            <template v-if="operateArtMap[item.id]">
              <button class="is-success" type="button" @click="onCompleteEdit(index, item)">
                <WorkbenchIcon name="check" :size="13" />{{ $t('art_complete_edit') }}
              </button>
              <button class="is-danger" type="button" @click="onCancelEdit(index, item)">
                <WorkbenchIcon name="x" :size="13" />{{ $t('art_cancel_edit') }}
              </button>
            </template>
            <template v-else>
              <button type="button" @click="onEdit(item)">{{ $t('art_edit') }}</button>
              <button class="is-danger" type="button" @click="onDelete(index, item)">{{ $t('art_delete') }}</button>
            </template>
          </span>
        </div>

        <div v-if="fileList.length === 0 && addFileList.length === 0" class="glossary-editor__empty">
          <span><WorkbenchIcon name="book-marked" :size="28" /></span>
          <strong>{{ searchString.length ? $t('art_not_search') : $t('art_entry_blank_tip') }}</strong>
        </div>
      </div>
    </div>

    <div class="glossary-editor__footer">
      <div v-if="termInfo && termInfo.updateTime" class="glossary-editor__meta">
        <span>{{ $t('art_updata_entry').replace('*', `${termInfo.entryNum}`) }}</span>
        <i />
        <span>{{ $t('art_updata_time').replace('*', `${formatDate(termInfo.updateTime, '', false)}`) }}</span>
      </div>
      <PageNation v-if="fileList.length > 0" :page="pageNum" :hasMore="hasMore" @changePage="onChangePage" />
    </div>
  </div>
</template>

<script setup lang="ts">
import {ElLoading} from "element-plus";
// import {
//   getRequestTermentrylist,
//   getRequestAddTermentry,
//   getRequestDeleteTermentry,
//   getRequestEditTermentry,
//   getRequestCheckTermKeyName,
//   getRequestExportExcelTerm
// } from "@/net/upload"
import Toast from "~/utils/toast";
import PageNation from "@/components/PageNation/PageNation.vue"
import ArtImportDialog from "@/components/Translate/Art/ArtImportDialog.vue"
import ArtLibraryDialog from "@/components/Translate/Art/ArtLibraryDialog.vue"
import WorkbenchIcon from '@/components/Workbench/WorkbenchIcon.vue'
import { getExcelJson } from '~/utils/ExcelUtils'

import {defineEmits, defineExpose, watch ,onMounted, onUnmounted, nextTick} from "vue";
import {useRuntimeConfig} from "nuxt/app";
// import {useRouter, useRoute} from "vue-router";
import useUserStore from "@/store/modules/user";
import AccountServer from "@/services/AccountServer";
import {storeToRefs} from "pinia";
import {useI18n} from "vue-i18n";
import eventBus from 'vue3-eventbus'

const router = useRouter()
const userStore = useUserStore();
const { userRights } = storeToRefs(userStore)
const fileList = ref<{blobFileName: string, createTime: string, fileType: string, origFileName: string,
  id: number, remark: string, tmpVisitorToken: string, userId: string, visible: boolean}[]>([])
const addFileList = ref([])
const fileMap = ref<{}>({})

const searchString = ref("")
const isChooseAll = ref(false)

const currentArtInfo = ref({})
const operateArtMap = ref({})

const artImportDialogShow = ref(false)
const excelJson = ref()
const uploadKey = ref(0)
const uploadRef = ref()
const currentFile = ref()
const artDialogShow = ref(false)
const artDialogType = ref(0)

const route = useRoute()
const { t, locale} = useI18n()

// 列表相关
const pageNum = ref(1)
const params = {pageSize: 5}
const hasMore = ref(true)

let call = defineEmits(["onUpPro", "updataList"])
defineExpose({ })

const props = defineProps({
  termInfo: {
    type: Object, // 0 翻译文档
    default: {}
  }
})

watch(
    () => searchString.value,
    (newVal, oldVal) => {
      resetParams()
      pageNum.value = 1
      params.prevPageId = null
      params.nextPageId = null
      requestFileList(false, true)
    },
    {
      deep: true
    }
)

onMounted(()=>{
  requestFileList(true, true)
})

const getLeftInputClass = (index) => {
  if (operateArtMap.value[index].leftFocus) {
    return "selectInput"
  }
  return ""
}

const getRightInputClass = (index) => {
  if (operateArtMap.value[index].rightFocus) {
    return "selectInput"
  }
  return ""
}

const getDeleteChooses = () => {
  return Object.keys(fileMap.value).length
}

// 事件
function onChooseAll() {
  isChooseAll.value = !isChooseAll.value
  if (isChooseAll.value) {
    fileList.value.forEach((item)=>{
      fileMap.value[item.id] = item
    })
  }else {
    fileMap.value = {}
  }
}

// 新建术语表词条
function onAddArtEntry() {
  let tempPamars = {id: 99999999, leftFocus: false, rightFocus:false, entryValue: '', temp: true, leftError: undefined, rightError: undefined}
  operateArtMap.value[99999999] = tempPamars
  addFileList.value.unshift({id: 99999999, entryKey: "", entryValue: '', temp: true, leftError: undefined, rightError: undefined})
}

// 导出
function onExportArt() {
  if (props.termInfo && props.termInfo.id) {
    AccountServer.getExportExcelTerm({termId: props.termInfo.id}).then((res)=> {
      try {
        let reader = new FileReader();
        reader.readAsDataURL(res as Blob);
        reader.onload = (e) => {  
          console.log(e)
          let a = document.createElement('a');
          a.download = props.termInfo.termName + '.xlsx';
          a.href = e.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }catch {
        Toast(t('art_export_fail'));
      }
    }).catch((error)=>{
      Toast(error && error.message);
    })
  }
}

// 删除术语表
function onDeleteArt() {
  if (props.termInfo && props.termInfo.id) {
    artDialogShow.value = true
    artDialogType.value = 6
  }
}

// 编辑
function onEdit(item) {
  console.log("onEdit", item)
  currentArtInfo.value = item
  operateArtMap.value[item.id] = {...item}
}

// 删除
function onDelete(index,item) {
  currentArtInfo.value = item
  if (props.termInfo && props.termInfo.id && !item.temp) {
    let param = {termId: props.termInfo.id, entryIds: `${item.id}`}
    AccountServer.getDeleteTermentry(param).then((data)=> {
      if (data.code == "1") {
        pageNum.value = 1
        params.prevPageId = null
        params.nextPageId = null
        requestFileList(false, true)
        delete operateArtMap.value[item.id]
        call("updataList")
      }
    }).catch((error)=>{
      Toast(error.message);
    })
  }else {
    delete operateArtMap.value[item.id]
    fileList.value.splice(index, 1)
  }
}

function isWhitespace(str) {
    if (str && str.length > 0) {
      return /^\s*$/.test(str);
    }
    return false
}

async function onCompleteEdit(index, item) {
  console.log("onCompleteEdit", operateArtMap.value, item)
  let entryKey = operateArtMap.value[item.id].entryKey
  let entryValue = operateArtMap.value[item.id].entryValue
  if (item.temp) {
    if (!entryKey || entryKey.length == 0) {
      addFileList.value[index].leftError = 1
      return
    }
    if (!entryValue || entryValue.length == 0) {
      addFileList.value[index].rightError = 1
      return
    }
    if (isWhitespace(entryKey)) {
      addFileList.value[index].leftError = 1
      return
    }
    if (isWhitespace(entryValue)) {
      addFileList.value[index].rightError = 1
      return
    }
    if (props.termInfo && props.termInfo.id) {
      let checkRes = await AccountServer.getCheckTermKeyName({termId:props.termInfo.id, entryKey: operateArtMap.value[item.id].entryKey})
      if (checkRes && checkRes.code == "1") {
        if (checkRes.data == false) {
          let param = {termId: props.termInfo.id, entryKey: operateArtMap.value[item.id].entryKey, entryValue: operateArtMap.value[item.id].entryValue}
          AccountServer.getAddTermentry(param).then((data)=> {
            if (data.code == "1") {
                addFileList.value = []
                delete operateArtMap.value[item.id]
                pageNum.value = 1
                params.prevPageId = null
                params.nextPageId = null
                requestFileList(false, true)
                call("updataList")
            }
          }).catch((result)=>{
            if (result && result.code == "10027") {
              // 单表词条超出
              artDialogType.value = 4
              artDialogShow.value = true
            }else if (result && result.code == "10028") {
              // 总词条超出
              artDialogType.value = 5
              artDialogShow.value = true
            }else {
              Toast(result && result.message)
            }
          })
        }else {
          addFileList.value[index].leftError = 2
        }
      }
    }
  }else {
    if (!entryKey || entryKey.length == 0) {
      fileList.value[index].leftError = 1
      return
    }
    if (!entryValue || entryValue.length == 0) {
      fileList.value[index].rightError = 1
      return
    }
    if (isWhitespace(entryKey)) {
      fileList.value[index].leftError = 1
      return
    }
    if (isWhitespace(entryValue)) {
      fileList.value[index].rightError = 1
      return
    }
    if (props.termInfo && props.termInfo.id) {
      if (item.entryKey != entryKey) {
        let checkRes = await AccountServer.getCheckTermKeyName({termId:props.termInfo.id, entryKey: entryValue})
        if (checkRes && checkRes.code == "1") {
          if (checkRes.data == true) {
            fileList.value[index].leftError = 2
            return
          }
        }
      }
      let param = {id: item.id, termId: props.termInfo.id, entryKey: entryKey, entryValue: entryValue}
      AccountServer.getEditTermentry(param).then((data)=> {
        if (data.code == "1") {
            delete operateArtMap.value[item.id]
            // requestFileList(false, true)
            fileList.value[index].entryValue = entryValue
            fileList.value[index].entryKey = entryKey
        }
      }).catch((error)=>{
        Toast(error && error.message);
      })
    }
  }
}

function onCancelEdit(index, item) {
  delete operateArtMap.value[item.id]
  if (item.temp) {
    addFileList.value = []
  }else {
    fileList.value[index].leftError = undefined
    fileList.value[index].rightError = undefined
  }
}

// 选中某一条
function onChooseItem(item) {
  if (fileMap.value[item.id]) {
    delete fileMap.value[item.id]
  }else {
    fileMap.value[item.id] = item
  }
  let chooseNum = Object.keys(fileMap.value).length
  let maxNum = fileList.value.length
  if (chooseNum == maxNum) {
    isChooseAll.value = true
  }else if (chooseNum == 0) {
    isChooseAll.value = false
  }
}
const handleLeftInput = (event, item) => {
  let value = event.target.value
  //输入位数限制
  if (value.length > 50) {
    value = value.slice(0, 50)
  }
  if (operateArtMap.value[item.id]) {
    operateArtMap.value[item.id].entryKey = value
    if(value.length) item.leftError = false
  }
}

const handleRightInput = (event, item) => {
  let value = event.target.value
  //输入位数限制
  if (value.length > 50) {
    value = value.slice(0, 50)
  }
  if (operateArtMap.value[item.id]) {
    operateArtMap.value[item.id].entryValue = value
    if(value.length) item.rightError = false
  }
}

// 列表请求
function requestFileList (isInit = false, needLoading = true) {
  let loading;
  if (needLoading) {
    let listDom = document.getElementById("fileArtList")
    if (listDom) {
      loading = ElLoading.service({
        lock: true,
        target: listDom
      })
    }
  }
  let param = {
    pageSize: 5,
    prevPageId: params.prevPageId,
    nextPageId: params.nextPageId,
    termId: props.termInfo.id
  }

  if (searchString.value && searchString.value.length > 0) {
    param.entryKey = searchString.value
  }

  AccountServer.getTermentrylist(param).then((data)=> {
    if (data.code == "1") {
      let list = data.list
      if (list && list.length > 0) {

        // list.forEach((item)=>{
        //   fileMap[item.id] = item
        // })
        fileList.value = list
        if (list.length === params.pageSize) {
          hasMore.value = true
        }else{
          hasMore.value = false
        }
      }else {
        if (!params.prevPageId && !params.nextPageId) {
          fileList.value = []
        }
        // fileList.value = []
        hasMore.value = false
      }
      loading && loading.close()
    }
  }).catch((error)=>{
    Toast(error.message);
  })
}

function onChangePage(change) {
  console.log("onChangePage", change)
  if (fileList.value.length > 0) {
    const lastItem = fileList.value[fileList.value.length - 1];
    const firstItem = fileList.value[0];
    if (change === 'prev') {
      pageNum.value = pageNum.value - 1
      params.prevPageId = firstItem.id
      params.nextPageId = null
    }else if (change === 'next') {
      pageNum.value = pageNum.value + 1
      params.prevPageId = null
      params.nextPageId = lastItem.id
    }
    resetParams()
    requestFileList(false, true)
  }
}

function onCloseDialog() {
  artImportDialogShow.value = false
  artDialogShow.value = false
  uploadRef.value && uploadRef.value.clearFiles()
}

function onConfirmDialog(dialogType, params) {
  artDialogShow.value = false
  if (dialogType == 4 || dialogType == 5) {
    call('onUpPro')
  }else if (dialogType == 6) {
    if (props.termInfo && props.termInfo.id) {
      let ids = []
      Object.keys(fileMap.value).forEach((key)=>{
        ids.push(key)
      })
      let param = {termId: props.termInfo.id, entryIds: ids.join(",")}
      AccountServer.getDeleteTermentry(param).then((data)=> {
        if (data.code == "1") {
            resetParams()
            pageNum.value = 1
            params.prevPageId = null
            params.nextPageId = null
            requestFileList(false, true)
            call("updataList")
        }
      }).catch((error)=>{
        Toast(error.message);
      })
    }
  }
}

function onDownloadFile() {
  let url = `https://doclingo.s3-accelerate.amazonaws.com/template/example.xlsx`
  const link = document.createElement('a');
  link.href = url;
  link.click();
}

function onUploadFile() {
  let ref = document.getElementById("art-edit-upload").querySelector('input')
  if (ref) {
    console.log("onBtnUpload", ref)
    ref.click()
  }
}

function onImportConfirmDialog(dialogType) {
  pageNum.value = 1
  params.prevPageId = null
  params.nextPageId = null
  resetParams()
  requestFileList(false, true)
  call("updataList")
  onCloseDialog()
}

function resetParams() {
  operateArtMap.value = {}
  addFileList.value = []
  isChooseAll.value = false
  fileMap.value = {}
}

// 上传相关
function handleBeforeUpload (file) {
  // handleUploads(file,uploadIndex)
  // 返回 false 以取消自动上传
  return false;
}

async function handleUploadFile (file, files) {
  console.log("handleUploadFile", file, files)
  currentFile.value = files[0].raw
  let isError = false
  let fileJson = await getExcelJson(files[0].raw).catch((error)=>{
    isError = true
    return []
  })
  let roleConfig = userRights.value
  if (fileJson) {
    if (roleConfig.termSingleTbSize && fileJson.length > roleConfig.termSingleTbSize) {
      // 这里超出行数
      artDialogType.value = 4
      artDialogShow.value = true
    }else if (fileJson && fileJson.length > 0 && Object.keys(fileJson[0]).length <= 1) {
      // 这里列数不足两条
      artDialogType.value = 9
      artDialogShow.value = true
    }else {
      excelJson.value = {jsonList: fileJson, isError: isError}
      artImportDialogShow.value = true
    }
  }else {
    artDialogType.value = 9
    artDialogShow.value = true
  }
  setTimeout(()=>{
    uploadKey.value += 1
  },1000)
}

// 在组件卸载前移除全局滚动事件监听器
onUnmounted(() => {
  // window.removeEventListener('scroll', handleScroll);
  // document.removeEventListener('click', handleClickOutside);
});

</script>

<style scoped lang="scss">
.artLibraryList{
  
  .query_menu_view{
    font-size: 14px;
    margin-left:20px;
    .query_menu_title{
      line-height: 40px;
      &:hover{
        cursor: pointer;
      }

    }
  }
}
.pageNation{
  margin-top: 10px;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .time {
    display: flex;
    flex-direction: row;
    align-items: center;
    .timeText {
      font-size: 12px;
      color: var(--text-color1);
    }
    .timeLine {
      display: flex;
      flex-direction: row;
      width: 1px;
      height: 12px;
      margin: 0 5px;
      background-color: #595959;
    }
  }
}
.responsive_time{
  display: none;
  flex-direction: row;
  align-items: center;
  margin:10px 0 0 0;
  .timeText {
    font-size: 12px;
    color: var(--text-color1);
  }
  .timeLine {
    display: flex;
    flex-direction: row;
    width: 1px;
    height: 12px;
    margin: 0 5px;
    background-color: #595959;
  }
}

.artTools {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 30px;
  .art-search {
    width: 200px;
    height: 30px;
  }
  .art-center-tools {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    .art-icon-view {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 2px;
      cursor: pointer;
      margin-left: 10px;
      &:hover {
        background-color: #F5F5F5;
      }
      .icon-icon_download1 {
        color: #2590E1;
      }
      .icon-icon_Import {
        color: #2590E1;
      }
      .iconfont{
        font-size: 22px;
      }
    }
  }
  .art-right {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .art-button {
      min-width: 100px;
    }
    .btn_view{
      display: flex;
      margin-right:10px;
    }
  }
}

.artLibraryList {
  display: flex;
  // max-height: 500px;
  width: 100%;
  //padding: 0 30px;
  flex-direction: column;
  margin-top: 10px;
  border: 1px solid #BFBFBF;
  .fileTop {
    width: 100%;
    height: 40px;
    display: flex;
    background-color: #EAF5FC;
    flex-direction: row;
    align-items: center;
    // box-shadow: 0px 0.5px 0px 0.5px #BFBFBF;
    border-bottom: 1px solid #BFBFBF;
    .itemHeader {
      display: flex; 
      flex-direction: row; 
      width: 100%; 
      height: 40px;
      align-items: center;
      .operateStart {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 85px;
        padding-left: 20px;
        cursor: pointer;
      }
      .operateEnd {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        width: 153px;
        padding-right: 20px;
      }
      .lock {
        margin-left: 10px;
        background: #FFFFFF;
        border-radius: 2px 2px 2px 2px;
        padding: 2px 5px;
        .lock-title {
          color: #595959;
          font-size: 12px;
          line-height: 12px;
        }
      }
      .title {
        font-size: 12px;
        color: var(--text-color1);
        margin-left: 5px;
      }
      .set_title_show{
       
      }
      .fileTop_first_title{
        margin-left: 20px;
      }
      .endTitle {
        font-weight: bold;
        font-size: 12px;
        color: var(--text-color1);
      }
      .failTitle {
        font-size: 12px;
        color: #E14C25;
      }
      .feedback—view{
        font-size: 12px;
        color:#2590E1;
        margin-right:10px;
      }
    }
    
  }
  .artList {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    .item {
      width: 100%;
      min-height: 50px;
      border-bottom: 1px solid #BFBFBF;
      display: flex;
      flex-direction: row;
      // align-items: center;
      flex-wrap: wrap;
      position: relative;
      .item-title {
        font-size: 12px;
        color: var(--text-color1);
        margin-left: 5px;
        margin-top: 18px;
        white-space: nowrap;      /* 禁止换行 */
        overflow: hidden;         /* 超出部分隐藏 */
        text-overflow: ellipsis;  /* 超出部分显示省略号 */
      }
      .operateItemStartBlank {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 85px;
        padding-left: 25px;
      }
      .operateItemStart {
        display: flex;
        flex-direction: row;
        width: 85px;
        padding-left: 20px;
        margin-top: 18px;
        cursor: pointer;
        .operateItemStart-title {
          font-size: 12px;
          color: var(--text-color1);
          margin-left: 5px;
        }
      }
      .operateItemEnd {
        display: flex;
        flex-direction: row;
        // align-items: center;
        justify-content: flex-end;
        // width: 107px;
        padding-right: 20px;
        margin-top: 18px;
        .item-end-title {
          font-size: 12px;
          color: #2590E1;
          margin-left: 20px;
          cursor: pointer;
          &:hover {
            opacity: 0.6;
          }
        }
        .icon-icon_correct {
          color: #34A853;
          font-size: 16px;
          cursor: pointer;
          margin-left: 20px;
          &:hover {
            opacity: 0.6;
          }
        }
        .icon-icon_error {
          color: #E14C25;
          font-size: 16px;
          cursor: pointer;
          margin-left: 20px;
          &:hover {
            opacity: 0.6;
          }
        }
      }
      .add_operateItemEnd{
        align-self: self-end;
      }
      .operateInput{
        flex: 1;
        display: flex;
        flex-direction: column;
        // width: calc(100% - 52px);
        margin-top: 10px;
        position: relative;
        // margin-right: 10px;
        // .screen-lg({
        //   margin-right: 0;
        // });
        // .screen-md({
        //   margin-right: 0;
        // });
        // .screen-sm({
        //   margin-right: 0;
        // });
        // .screen-xs({
        //   margin-right: 0;
        // });
        .chooseImportSelectInput {
          // width: calc(100% - 20px);
          // width: 100%;
          font-size: 12px;
          height: 28px;
          border: 1px solid #BFBFBF;
          padding: 0 50px 0 10px;/*清除自带的padding间距*/
          outline: none;/*清除input点击之后的黑色边框*/
          background-color: white;
          text-align: start;
          border-radius: 4px;
          // margin-right: 20px;
          // margin-left: 10px;
        }
        .input-position {
          position: absolute;
          right: 10px;
          top: 6px;
          color: #BFBFBF;
          font-size: 14px;
        }
        input::-webkit-input-placeholder {
          /* placeholder颜色 */
          color: #BFBFBF;
          /* placeholder字体大小 */
          font-size: 12px;
          position: relative;
        }
        .selectInput {
          border: 1px solid #2590E1;
        }
        .errorInput {
          border: 1px solid #BFBFBF;
        }
        .errorView {
          display: flex;
          flex-direction: row;
          align-items: center;
          flex: 1;
          margin: 5px 0px 5px 0px;
          .icon-icon_question {
            font-size: 16px;
            color: #E14C25
          }
          .errorText {
            font-size: 12px;
            color: #E14C25;
            margin-left: 5px;
          }
        }
      }

      .add_operateItemStart_view{
        width: 100%;
        display: flex;
        justify-content: space-between;
      }

      .add_operateInput_view{
        
      }
      


      .operateInput_parent_view{
        display: flex;
        flex: 1;
        justify-content: space-between;
        position: absolute;
        left:105px;
        right:173px;
        .operateInput_view{
          flex: none !important;
          width: 47%;
          .item-title{
            margin-left:5 !important;
          }
        }
      }
    }
    .item:last-child{
      border-bottom: none;
    }
    .set_error_height{
      min-height: 70px;
    }
    .operateItemStart_view{
      width: 100%;
      display: flex;
      justify-content: space-between;

    }
    .blank {
      width: 100%;
      height: 500px;
      justify-content: center;
      flex-direction: column;
      display: flex;
      align-items: center;
      .icon-icon_blank_1 {
        font-size: 48px;
        color: #BFBFBF;
      }
      .blank-title {
        margin-top: 10px;
        font-size: 12px;
        color: #BFBFBF
      }
      .blank-btn {
        margin-top: 30px;
        min-width: 142px;
        height: 30px;
      }
      .blank-operate {
        margin-top: 10px;
        flex-direction: row;
        display: flex;
        align-items: center;
        .blank-download {
          font-size: 12px;
          color: #2590E1;
          cursor: pointer;
          &:hover {
            opacity: 0.6;
          }
        }
        .blank-space {
          width: 1px;
          height: 12px;
          background: #2590E1;
          margin: 0 10px;
        }
        .blank-import {
          font-size: 12px;
          color: #2590E1;
          cursor: pointer;
          &:hover {
            opacity: 0.6;
          }
        }
      }
      .blank-describe {
        margin-top: 30px;
        flex-direction: row;
        display: flex;
        align-items: center;
        cursor: pointer;
        .describe-title {
          color: #8C8C8C;
          font-size: 12px;
        }
        .icon-icon_arrowsrigh {
          color: #8C8C8C;
          font-size: 12px;
          margin-left: 4px;
        }
        &:hover {
          opacity: 0.6;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.glossary-editor {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 12px;
}

.glossary-editor__upload {
  height: 0;
  overflow: hidden;
}

.glossary-editor__toolbar {
  display: flex;
  min-height: 34px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.glossary-editor__search {
  display: flex;
  width: min(280px, 30vw);
  height: 34px;
  align-items: center;
  gap: 8px;
  padding: 0 11px;
  color: #98a2b3;
  background: #f7f8fa;
  border: 1px solid #e8ebf0;
  border-radius: 8px;

  &:focus-within {
    color: #2b7de9;
    background: #fff;
    border-color: #2b7de9;
  }

  input {
    min-width: 0;
    flex: 1;
    color: #1f2329;
    font: inherit;
    font-size: 12px;
    background: transparent;
    border: 0;
    outline: 0;

    &::placeholder {
      color: #98a2b3;
    }

    &::-webkit-search-cancel-button {
      display: none;
    }
  }
}

.glossary-editor__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.glossary-editor__divider {
  width: 1px;
  height: 20px;
  margin: 0 2px;
  background: #e8ebf0;
}

.glossary-editor__icon-button,
.glossary-editor__button,
.glossary-editor__check,
.glossary-entry-actions button {
  font: inherit;
}

.glossary-editor__icon-button {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  color: #2b7de9;
  background: #fff;
  border: 1px solid #d9e0e8;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: #f5f9ff;
    border-color: #2b7de9;
  }
}

.glossary-editor__button {
  display: inline-flex;
  height: 34px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 13px;
  color: #4b5563;
  font-size: 12px;
  font-weight: 600;
  background: #fff;
  border: 1px solid #d9e0e8;
  border-radius: 8px;
  cursor: pointer;

  &:not(:disabled):hover {
    color: #2b7de9;
    border-color: #2b7de9;
  }

  &:disabled {
    color: #b8c0cc;
    background: #f7f8fa;
    border-color: #e8ebf0;
    cursor: not-allowed;
  }
}

.glossary-editor__button--primary {
  color: #fff;
  background: #2b7de9;
  border-color: #2b7de9;

  &:not(:disabled):hover {
    color: #fff;
    background: #1f6fd6;
  }
}

.glossary-editor__table-shell {
  min-width: 0;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e8ebf0;
  border-radius: 10px;
}

.glossary-entry-grid {
  display: grid;
  grid-template-columns: 26px 72px minmax(210px, 1fr) minmax(210px, 1fr) 170px;
  align-items: center;
  column-gap: 8px;
  padding: 0 16px;
}

.glossary-editor__table-header {
  min-height: 42px;
  color: #51565d;
  font-size: 12px;
  font-weight: 600;
  background: #f5f9ff;
  border-bottom: 1px solid #e8ebf0;
}

.glossary-editor__operation-title {
  text-align: right;
}

.glossary-editor__table-body {
  position: relative;
  min-height: 392px;
}

.glossary-entry-row {
  min-height: 58px;
  color: #51565d;
  font-size: 12px;
  border-bottom: 1px solid #f2f5f9;

  &:last-of-type {
    border-bottom: 0;
  }

  &:hover {
    background: #fbfdff;
  }

  &.is-editing {
    min-height: 76px;
    background: #fbfdff;
  }
}

.glossary-editor__check {
  display: inline-flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #fff;
  background: #fff;
  border: 1px solid #c8d0da;
  border-radius: 4px;
  cursor: pointer;

  &[aria-pressed='true'] {
    background: #2b7de9;
    border-color: #2b7de9;
  }
}

.glossary-entry-index {
  color: #98a2b3;
  font-variant-numeric: tabular-nums;
}

.glossary-entry-text {
  min-width: 0;
  overflow: hidden;
  color: #1f2329;
  font-size: 12.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.glossary-entry-field {
  position: relative;
  min-width: 0;
  padding: 7px 0 17px;

  input {
    width: 100%;
    height: 34px;
    padding: 0 46px 0 10px;
    color: #1f2329;
    font: inherit;
    font-size: 12px;
    background: #fff;
    border: 1px solid #d9e0e8;
    border-radius: 7px;
    outline: none;

    &:focus,
    &.selectInput {
      border-color: #2b7de9;
      box-shadow: 0 0 0 2px rgba(43, 125, 233, 0.1);
    }
  }

  em {
    position: absolute;
    top: 17px;
    right: 8px;
    color: #b8c0cc;
    font-size: 10px;
    font-style: normal;
  }

  small {
    position: absolute;
    right: 0;
    bottom: 2px;
    left: 0;
    overflow: hidden;
    color: #e05555;
    font-size: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.glossary-entry-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;

  button {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 0;
    color: #2b7de9;
    font-size: 12px;
    background: transparent;
    border: 0;
    cursor: pointer;

    &.is-danger {
      color: #e05555;
    }

    &.is-success {
      color: #2fb67c;
    }
  }
}

.glossary-editor__empty {
  display: flex;
  min-height: 392px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #98a2b3;

  > span {
    display: inline-flex;
    width: 54px;
    height: 54px;
    align-items: center;
    justify-content: center;
    color: #2b7de9;
    background: #edf5ff;
    border-radius: 14px;
  }

  strong {
    margin-top: 12px;
    color: #51565d;
    font-size: 13px;
    font-weight: 600;
  }
}

.glossary-editor__footer {
  display: flex;
  min-height: 30px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.glossary-editor__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #98a2b3;
  font-size: 11px;

  i {
    width: 1px;
    height: 11px;
    background: #d9e0e8;
  }
}

@media (max-width: 1050px) {
  .glossary-editor__toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .glossary-editor__search {
    width: 100%;
  }

  .glossary-editor__actions {
    flex-wrap: wrap;
  }

  .glossary-editor__table-shell {
    overflow-x: auto;
  }

  .glossary-entry-grid {
    min-width: 880px;
  }
}
</style>

<style scoped>
.art-custom-input :deep(.el-input__inner) {
  background-color: #F5F5F5; /* 修改背景颜色 */
  border: none; /* 移除边框 */
  box-shadow: none; /* 移除默认的阴影 */
}

.art-custom-input :deep(.el-input__wrapper) {
  background-color: #F5F5F5; /* 修改背景颜色 */
  border: none; /* 移除边框 */
  box-shadow: none; /* 移除默认的阴影 */
}
</style>
<style lang="scss">
.artLibraryList input {
    font-size: 12px !important; /* 设置字体大小 */
}
.artLibraryList textarea {
  font-size: 12px !important; /* 设置字体大小 */
}
</style>
